export default __webpack_public_path__ + "static/media/icon-instructions.b707f8cc.svg";